import { render } from "./HelloWorld.vue?vue&type=template&id=5cc7f8f0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=5cc7f8f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5cc7f8f0"

export default script